module.exports = __webpack_public_path__ + "static/review-applicants-6b79e47cb938d7dad4e285f6aa2f6ed9.png";